import styled from 'styled-components';
import Modal from '../Modal';

const StyledModal = styled(Modal)`
  &.download-notification {
    width: 500px;
    height: 250px;
  }
`;

export default StyledModal;



// WEBPACK FOOTER //
// ./app/components/DownloadNotifications/StyledModal.js